import React from "react";

export function PendingChip({ label = "Pending", tone = "warning" }) {
  const isWarning = tone === "warning";
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      background: isWarning ? "#FFFBEB" : "#F0F0F0",
      border: isWarning ? "1px solid #F59E0B55" : "1px solid #CFCFCF",
      color: isWarning ? "#B45309" : "#626262",
      fontSize: 10,
      fontWeight: 600,
      padding: "2px 8px",
      borderRadius: 20,
      whiteSpace: "nowrap",
    }}>
      {label}
    </span>
  );
}
